export type MethodsGroup =
  | 'applePay'
  | 'card'
  | 'payInPerson'
  | 'cashApp'
  | 'bnpl';

const METHODS_ORDER_BY_BRAND = new Map<string, MethodsGroup[]>([
  // Otis & Finn Barbershop
  [
    'bb4821f1-75d5-4540-8bd8-9e43fcfb8173',
    ['payInPerson', 'card', 'applePay', 'cashApp', 'bnpl'],
  ],
]);

const METHODS_ORDER_DEFAULT: MethodsGroup[] = [
  'applePay',
  'card',
  'payInPerson',
  'cashApp',
  'bnpl',
];

export const getPaymentMethodsOrder = (brandId?: string): MethodsGroup[] => {
  return METHODS_ORDER_BY_BRAND.get(brandId ?? '') ?? METHODS_ORDER_DEFAULT;
};
